
// import { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   Globe,
//   Building2,
//   BookOpen,
//   Landmark,
//   Leaf,
//   Users,
//   ArrowUpRight,
//   Sparkles,
// } from "lucide-react";

// const focusAreas = [
//   {
//     number: "01",
//     icon: Globe,
//     title: "Global Outreach",
//     short: "Global",
//     desc: "Connecting India with global industries and strategic partners.",
//   },
//   {
//     number: "02",
//     icon: Building2,
//     title: "Business Development Services",
//     short: "Business",
//     desc: "Enabling business growth and enterprise development.",
//   },
//   {
//     number: "03",
//     icon: BookOpen,
//     title: "Knowledge Work",
//     short: "Knowledge",
//     desc: "Advancing research and insights on FTAs, international trade, macroeconomics, and key sectors.",
//   },
//   {
//     number: "04",
//     icon: Landmark,
//     title: "Policy Advocacy",
//     short: "Policy",
//     desc: "Driving policy dialogue and strengthening government–industry partnerships.",
//   },
//   {
//     number: "05",
//     icon: Leaf,
//     title: "Sustainability Services",
//     short: "Sustainability",
//     desc: "Advancing green growth through certifications, advisory, and policy advocacy.",
//   },
//   {
//     number: "06",
//     icon: Users,
//     title: "CSR Services",
//     short: "CSR",
//     desc: "Promoting inclusive development through impactful social initiatives.",
//   },
// ];

// // 6 evenly-spaced positions around a circle
// const CENTER = 200;
// const RADIUS = 145;
// const nodePositions = focusAreas.map((_, i) => {
//   // start at -90° so first item is at the top, step clockwise 60°
//   const angleDeg = -90 + i * 60;
//   const rad = (angleDeg * Math.PI) / 180;
//   return {
//     x: CENTER + RADIUS * Math.cos(rad),
//     y: CENTER + RADIUS * Math.sin(rad),
//     angle: angleDeg,
//   };
// });

// const PRIMARY = "#DA2128";
// const ACCENT = "#FF6A3D";

// /* --------------- Beautiful orbital infographic --------------- */
// function OrbitalInfographic({ active, setActive }) {
//   return (
//     <div className="relative mx-auto aspect-square w-full max-w-[480px]">
//       {/* Outer soft glow */}
//       <div
//         className="absolute inset-0 rounded-full blur-3xl"
//         style={{
//           background:
//             "radial-gradient(circle at center, rgba(218,33,40,0.12) 0%, rgba(255,106,61,0.05) 40%, transparent 70%)",
//         }}
//       />

//       <svg
//         viewBox="0 0 400 400"
//         className="absolute inset-0 h-full w-full"
//         fill="none"
//       >
//         <defs>
//           <radialGradient id="hubGlow" cx="50%" cy="50%" r="50%">
//             <stop offset="0%" stopColor={PRIMARY} stopOpacity="0.35" />
//             <stop offset="60%" stopColor={PRIMARY} stopOpacity="0.08" />
//             <stop offset="100%" stopColor={PRIMARY} stopOpacity="0" />
//           </radialGradient>
//           <linearGradient id="activeLine" x1="0" y1="0" x2="1" y2="1">
//             <stop offset="0%" stopColor={PRIMARY} />
//             <stop offset="100%" stopColor={ACCENT} />
//           </linearGradient>
//           <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
//             <feOffset dx="0" dy="4" result="offsetblur" />
//             <feComponentTransfer>
//               <feFuncA type="linear" slope="0.25" />
//             </feComponentTransfer>
//             <feMerge>
//               <feMergeNode />
//               <feMergeNode in="SourceGraphic" />
//             </feMerge>
//           </filter>
//           <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="5" result="blur" />
//             <feMerge>
//               <feMergeNode in="blur" />
//               <feMergeNode in="SourceGraphic" />
//             </feMerge>
//           </filter>
//         </defs>

//         {/* Outer fill glow for center */}
//         <circle cx={CENTER} cy={CENTER} r="180" fill="url(#hubGlow)" />

//         {/* Two slowly rotating orbit rings */}
//         <g style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}>
//           <motion.circle
//             cx={CENTER}
//             cy={CENTER}
//             r={RADIUS + 10}
//             stroke={PRIMARY}
//             strokeOpacity="0.12"
//             strokeWidth="1"
//             strokeDasharray="2 6"
//             fill="none"
//             animate={{ rotate: 360 }}
//             transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
//             style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
//           />
//         </g>
//         <g style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}>
//           <motion.circle
//             cx={CENTER}
//             cy={CENTER}
//             r={RADIUS - 18}
//             stroke={ACCENT}
//             strokeOpacity="0.18"
//             strokeWidth="1"
//             strokeDasharray="1 4"
//             fill="none"
//             animate={{ rotate: -360 }}
//             transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
//             style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
//           />
//         </g>

//         {/* Static outer orbit */}
//         <circle
//           cx={CENTER}
//           cy={CENTER}
//           r={RADIUS}
//           stroke={PRIMARY}
//           strokeOpacity="0.2"
//           strokeWidth="1"
//           fill="none"
//         />

//         {/* Curved arc connectors (quadratic curves for organic look) */}
//         {nodePositions.map((pos, i) => {
//           const isActive = active === i;
//           // control point slightly pulled toward center for a soft arc
//           const midX = (CENTER + pos.x) / 2;
//           const midY = (CENTER + pos.y) / 2;
//           // Pull curve toward the center slightly
//           const dx = CENTER - midX;
//           const dy = CENTER - midY;
//           const dist = Math.sqrt(dx * dx + dy * dy);
//           const pull = 18; // curve amount
//           const cpX = midX + (dx / dist) * pull;
//           const cpY = midY + (dy / dist) * pull;
//           return (
//             <g key={`arc-${i}`}>
//               <motion.path
//                 d={`M ${CENTER} ${CENTER} Q ${cpX} ${cpY} ${pos.x} ${pos.y}`}
//                 stroke={isActive ? "url(#activeLine)" : "#DA2128"}
//                 strokeOpacity={isActive ? 1 : 0.25}
//                 strokeWidth={isActive ? 2.5 : 1.2}
//                 strokeLinecap="round"
//                 fill="none"
//                 initial={{ pathLength: 0, opacity: 0 }}
//                 whileInView={{ pathLength: 1, opacity: 1 }}
//                 viewport={{ once: true }}
//                 transition={{
//                   duration: 0.9,
//                   delay: 0.3 + i * 0.12,
//                   ease: "easeOut",
//                 }}
//               />
//             </g>
//           );
//         })}

//         {/* Tiny decorative tick dots on the orbit */}
//         {nodePositions.map((pos, i) => {
//           // put small dots halfway along the orbit between each node
//           const midAngle = pos.angle + 30;
//           const rad = (midAngle * Math.PI) / 180;
//           const mx = CENTER + RADIUS * Math.cos(rad);
//           const my = CENTER + RADIUS * Math.sin(rad);
//           return (
//             <motion.circle
//               key={`tick-${i}`}
//               cx={mx}
//               cy={my}
//               r="2"
//               fill={PRIMARY}
//               fillOpacity="0.4"
//               initial={{ scale: 0 }}
//               whileInView={{ scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ delay: 1 + i * 0.1 }}
//             />
//           );
//         })}
//       </svg>

//       {/* Center hub */}
//       <motion.div
//         initial={{ scale: 0, opacity: 0 }}
//         whileInView={{ scale: 1, opacity: 1 }}
//         viewport={{ once: true }}
//         transition={{ type: "spring", stiffness: 180, damping: 14, delay: 0.1 }}
//         className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
//       >
//         {/* Pulsing rings */}
//         <motion.span
//           className="absolute left-1/2 top-1/2 block h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full"
//           style={{ backgroundColor: PRIMARY, opacity: 0.1 }}
//           animate={{ scale: [1, 1.35, 1], opacity: [0.15, 0, 0.15] }}
//           transition={{
//             duration: 3.2,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//         />
//         <motion.span
//           className="absolute left-1/2 top-1/2 block h-36 w-36 -translate-x-1/2 -translate-y-1/2 rounded-full"
//           style={{ backgroundColor: ACCENT, opacity: 0.08 }}
//           animate={{ scale: [1, 1.5, 1], opacity: [0.12, 0, 0.12] }}
//           transition={{
//             duration: 3.2,
//             repeat: Infinity,
//             ease: "easeInOut",
//             delay: 1.2,
//           }}
//         />

//         {/* Main hub */}
//         <div
//           className="relative flex h-28 w-28 flex-col items-center justify-center rounded-full text-white shadow-2xl ring-4 ring-white"
//           style={{
//             background: `radial-gradient(circle at 30% 30%, #ff5c63 0%, ${PRIMARY} 55%, #8f0f14 100%)`,
//             boxShadow: `0 20px 50px -10px ${PRIMARY}60, 0 0 0 8px ${PRIMARY}10`,
//           }}
//         >
//           {/* Glass highlight */}
//           <div
//             className="absolute top-2 left-3 h-6 w-10 rounded-full bg-white/25 blur-md"
//             style={{ borderRadius: "50%" }}
//           />
//           <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-white/85">
//             ASSOCHAM
//           </span>
//           <span className="mt-1 text-[13px] font-black leading-none tracking-tight">
//             Focus
//           </span>
//           <span className="mt-1 text-[9px] font-medium uppercase tracking-[0.2em] text-white/80">
//             6 Pillars
//           </span>
//         </div>
//       </motion.div>

//       {/* Outer nodes (positioned with percentages for responsiveness) */}
//       {focusAreas.map((area, i) => {
//         const pos = nodePositions[i];
//         const Icon = area.icon;
//         const isActive = active === i;
//         const leftPct = (pos.x / 400) * 100;
//         const topPct = (pos.y / 400) * 100;

//         // Label positioning: push label outward from center
//         const rad = (pos.angle * Math.PI) / 180;
//         const labelOffset = 46;
//         const labelX = pos.x + labelOffset * Math.cos(rad);
//         const labelY = pos.y + labelOffset * Math.sin(rad);
//         const labelLeftPct = (labelX / 400) * 100;
//         const labelTopPct = (labelY / 400) * 100;

//         return (
//           <div key={area.number}>
//             {/* Node button */}
//             <motion.button
//               initial={{ scale: 0, opacity: 0 }}
//               whileInView={{ scale: 1, opacity: 1 }}
//               viewport={{ once: true }}
//               transition={{
//                 type: "spring",
//                 stiffness: 220,
//                 damping: 16,
//                 delay: 0.6 + i * 0.1,
//               }}
//               animate={{
//                 y: isActive ? -3 : 0,
//               }}
//               whileHover={{ scale: 1.1, y: -3 }}
//               onMouseEnter={() => setActive(i)}
//               className="absolute z-20 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
//               style={{ left: `${leftPct}%`, top: `${topPct}%` }}
//             >
//               {/* outer ring when active */}
//               {isActive && (
//                 <motion.span
//                   layoutId="nodeGlow"
//                   className="absolute inset-[-8px] rounded-2xl"
//                   style={{
//                     background: `linear-gradient(135deg, ${PRIMARY}40, ${ACCENT}30)`,
//                     filter: "blur(10px)",
//                   }}
//                   transition={{
//                     type: "spring",
//                     stiffness: 300,
//                     damping: 25,
//                   }}
//                 />
//               )}
//               <motion.div
//                 className={`relative flex h-[52px] w-[52px] items-center justify-center rounded-2xl ring-1 transition-all duration-300 ${
//                   isActive
//                     ? "text-white ring-white/60"
//                     : "bg-white text-[#DA2128] ring-gray-200 shadow-md"
//                 }`}
//                 animate={{
//                   background: isActive
//                     ? `linear-gradient(135deg, ${PRIMARY} 0%, ${ACCENT} 100%)`
//                     : "#ffffff",
//                   boxShadow: isActive
//                     ? `0 12px 30px -8px ${PRIMARY}80`
//                     : "0 4px 12px -4px rgba(0,0,0,0.08)",
//                 }}
//                 transition={{ duration: 0.3 }}
//               >
//                 <Icon size={22} strokeWidth={2.2} />
//               </motion.div>
//             </motion.button>

//             {/* Outer label pill */}
//             <motion.div
//               initial={{ opacity: 0, scale: 0.8 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.9 + i * 0.1, duration: 0.4 }}
//               className="pointer-events-none absolute z-10 -translate-x-1/2 -translate-y-1/2"
//               style={{
//                 left: `${labelLeftPct}%`,
//                 top: `${labelTopPct}%`,
//               }}
//             >
//               <span
//                 className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[10px] font-bold tracking-wide transition-all duration-300 ${
//                   isActive
//                     ? "bg-gradient-to-r from-[#DA2128] to-[#FF6A3D] text-white shadow-md"
//                     : "bg-white/90 text-gray-700 shadow-sm ring-1 ring-gray-200/70 backdrop-blur-sm"
//                 }`}
//               >
//                 {area.short}
//               </span>
//             </motion.div>
//           </div>
//         );
//       })}

//       {/* Corner sparkle decorations */}
//       <motion.div
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 1 }}
//         viewport={{ once: true }}
//         transition={{ delay: 1.4 }}
//         className="absolute top-4 right-6 text-amber-400"
//       >
//         <motion.span
//           animate={{ rotate: [0, 15, -15, 0], scale: [1, 1.2, 1] }}
//           transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
//           className="inline-block"
//         >
//           <Sparkles size={14} />
//         </motion.span>
//       </motion.div>
//       <motion.div
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 1 }}
//         viewport={{ once: true }}
//         transition={{ delay: 1.6 }}
//         className="absolute bottom-8 left-4 text-[#DA2128]/70"
//       >
//         <motion.span
//           animate={{ rotate: [0, -20, 20, 0], scale: [1, 1.3, 1] }}
//           transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
//           className="inline-block"
//         >
//           <Sparkles size={12} />
//         </motion.span>
//       </motion.div>
//     </div>
//   );
// }

// export default function FocusArea() {
//   const [active, setActive] = useState(0);
//   const activeArea = focusAreas[active];

//   return (
//     <section
//       id="focus"
//       className="relative overflow-hidden bg-gradient-to-b from-white via-[#FFFAF8] to-white py-20 md:py-28"
//     >
//       {/* Decorative background orbs */}
//       <div className="pointer-events-none absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full bg-[#DA2128]/[0.07] blur-3xl" />
//       <div className="pointer-events-none absolute -left-32 -bottom-32 h-[460px] w-[460px] rounded-full bg-[#FF6A3D]/[0.06] blur-3xl" />
//       <div className="pointer-events-none absolute left-1/2 top-1/3 h-72 w-72 -translate-x-1/2 rounded-full bg-amber-200/10 blur-3xl" />

//       {/* Subtle grid */}
//       <div
//         className="pointer-events-none absolute inset-0 opacity-[0.025]"
//         style={{
//           backgroundImage:
//             "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
//           backgroundSize: "44px 44px",
//         }}
//       />

//       <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//         {/* Heading */}
//         <div className="mb-12 text-center md:mb-16">
//           <motion.span
//             initial={{ opacity: 0, y: 10 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mb-4 inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/20 bg-white px-4 py-1.5 text-[10px] font-bold tracking-[0.25em] text-[#DA2128] uppercase shadow-sm"
//           >
//             <Sparkles size={10} />
//             Our Focus
//           </motion.span>
//           <motion.h2
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: 0.05 }}
//             className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl md:text-5xl"
//           >
//             Where We Drive{" "}
//             <span
//               className="bg-clip-text text-transparent"
//               style={{
//                 backgroundImage: `linear-gradient(120deg, ${PRIMARY}, ${ACCENT})`,
//               }}
//             >
//               Impact
//             </span>
//           </motion.h2>
//           <motion.div
//             initial={{ scaleX: 0 }}
//             whileInView={{ scaleX: 1 }}
//             viewport={{ once: true }}
//             transition={{ delay: 0.3, duration: 0.6 }}
//             className="mx-auto mt-4 h-1 w-20 rounded-full bg-gradient-to-r from-[#DA2128] to-[#FF6A3D]"
//           />
//           <motion.p
//             initial={{ opacity: 0, y: 15 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: 0.1 }}
//             className="mx-auto mt-5 max-w-3xl text-sm leading-relaxed text-gray-600 sm:text-base"
//           >
//             At ASSOCHAM, the Industry Voice of India, we are committed to
//             creating an ecosystem where collaboration drives progress. By
//             bringing together industry, government, academia, and global
//             stakeholders, we facilitate dialogue, promote innovation, and
//             advance initiatives that contribute to India's economic development
//             and long-term growth.
//           </motion.p>
//         </div>

//         {/* Two column layout */}
//         <div className="grid items-center gap-10 md:grid-cols-2 lg:gap-14">
//           {/* LEFT: Infographic */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.92 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true, margin: "-60px" }}
//             transition={{ duration: 0.7 }}
//             className="relative mx-auto w-full max-w-[480px]"
//           >
//             <OrbitalInfographic active={active} setActive={setActive} />

//             {/* Active label under infographic (mobile+desktop) */}
//             {/* <AnimatePresence mode="wait">
//               <motion.div
//                 key={activeArea.number}
//                 initial={{ opacity: 0, y: 10 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -10 }}
//                 transition={{ duration: 0.3 }}
//                 className="mt-6 rounded-2xl border border-gray-200/70 bg-white/80 p-4 text-center shadow-sm backdrop-blur-sm"
//               >
               
//                 <p className="mt-1 text-base font-bold text-gray-900 sm:text-lg">
//                   {activeArea.title}
//                 </p>
//               </motion.div>
//             </AnimatePresence> */}
//           </motion.div>

//           {/* RIGHT: Focus cards */}
//           <div className="space-y-3">
//             {focusAreas.map((area, i) => {
//               const Icon = area.icon;
//               const isActive = active === i;
//               return (
//                 <motion.div
//                   key={area.number}
//                   initial={{ opacity: 0, x: 40 }}
//                   whileInView={{ opacity: 1, x: 0 }}
//                   viewport={{ once: true, margin: "-40px" }}
//                   transition={{ duration: 0.5, delay: i * 0.07 }}
//                   onMouseEnter={() => setActive(i)}
//                   className={`group relative flex cursor-pointer items-start gap-4 overflow-hidden rounded-2xl border p-4 transition-all duration-300 sm:p-5 ${
//                     isActive
//                       ? "border-transparent bg-white shadow-xl shadow-[#DA2128]/10"
//                       : "border-gray-200/70 bg-white/60 hover:border-[#DA2128]/20 hover:bg-white hover:shadow-md"
//                   }`}
//                   style={{
//                     background: isActive
//                       ? "linear-gradient(110deg, #ffffff 0%, #fff5f3 100%)"
//                       : undefined,
//                   }}
//                 >
//                   {/* Left gradient accent */}
//                   <motion.div
//                     initial={false}
//                     animate={{ scaleY: isActive ? 1 : 0, opacity: isActive ? 1 : 0 }}
//                     transition={{ duration: 0.3 }}
//                     className="absolute left-0 top-0 h-full w-1 origin-top bg-gradient-to-b from-[#DA2128] to-[#FF6A3D]"
//                   />

//                   {/* Number */}
//                   <span
//                     className={`absolute top-3 right-4 text-[10px] font-black tracking-wider transition-colors ${
//                       isActive ? "text-[#DA2128]" : "text-gray-300"
//                     }`}
//                   >
//                     {area.number}
//                   </span>

//                   {/* Icon */}
//                   <motion.div
//                     animate={{
//                       background: isActive
//                         ? `linear-gradient(135deg, ${PRIMARY}, ${ACCENT})`
//                         : "rgba(218,33,40,0.08)",
//                       color: isActive ? "#ffffff" : "#DA2128",
//                       scale: isActive ? 1.05 : 1,
//                     }}
//                     whileHover={{ rotate: [0, -6, 6, 0] }}
//                     transition={{ duration: 0.3 }}
//                     className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl shadow-sm"
//                   >
//                     <Icon size={20} strokeWidth={2.2} />
//                   </motion.div>

//                   {/* Content */}
//                   <div className="flex-1 pr-8">
//                     <h3 className="text-[15px] font-bold leading-snug text-gray-900 sm:text-base">
//                       {area.title}
//                     </h3>
//                     <AnimatePresence initial={false}>
//                       {isActive && (
//                         <motion.p
//                           key={`desc-${area.number}`}
//                           initial={{ opacity: 0, height: 0, marginTop: 0 }}
//                           animate={{
//                             opacity: 1,
//                             height: "auto",
//                             marginTop: 6,
//                           }}
//                           exit={{ opacity: 0, height: 0, marginTop: 0 }}
//                           transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
//                           className="overflow-hidden text-[13px] leading-relaxed text-gray-600"
//                         >
//                           {area.desc}
//                         </motion.p>
//                       )}
//                     </AnimatePresence>
//                   </div>

//                   {/* Arrow icon on active */}
//                   <motion.div
//                     animate={{
//                       opacity: isActive ? 1 : 0,
//                       x: isActive ? 0 : -4,
//                     }}
//                     transition={{ duration: 0.25 }}
//                     className="absolute right-4 bottom-4 self-end"
//                   >
//                     <div
//                       className="flex h-7 w-7 items-center justify-center rounded-full text-white"
//                       style={{
//                         background: `linear-gradient(135deg, ${PRIMARY}, ${ACCENT})`,
//                       }}
//                     >
//                       <ArrowUpRight size={14} strokeWidth={2.5} />
//                     </div>
//                   </motion.div>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }





// new code 




import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Globe,
  Building2,
  BookOpen,
  Landmark,
  Leaf,
  Users,
  ArrowUpRight,
  Sparkles,
} from "lucide-react";

const focusAreas = [
  {
    number: "01",
    icon: Globe,
    title: "Global Outreach",
    short: "Global",
    desc: "Connecting India with global industries and strategic partners.",
  },
  {
    number: "02",
    icon: Building2,
    title: "Business Development Services",
    short: "Business",
    desc: "Enabling business growth and enterprise development.",
  },
  {
    number: "03",
    icon: BookOpen,
    title: "Knowledge Work",
    short: "Knowledge",
    desc: "Advancing research and insights on FTAs, international trade, macroeconomics, and key sectors.",
  },
  {
    number: "04",
    icon: Landmark,
    title: "Policy Advocacy",
    short: "Policy",
    desc: "Driving policy dialogue and strengthening government–industry partnerships.",
  },
  {
    number: "05",
    icon: Leaf,
    title: "Sustainability Services",
    short: "Sustainability",
    desc: "Advancing green growth through certifications, advisory, and policy advocacy.",
  },
  {
    number: "06",
    icon: Users,
    title: "CSR Services",
    short: "CSR",
    desc: "Promoting inclusive development through impactful social initiatives.",
  },
];

// 6 evenly-spaced positions around a circle
const CENTER = 200;
const RADIUS = 145;
const nodePositions = focusAreas.map((_, i) => {
  // start at -90° so first item is at the top, step clockwise 60°
  const angleDeg = -90 + i * 60;
  const rad = (angleDeg * Math.PI) / 180;
  return {
    x: CENTER + RADIUS * Math.cos(rad),
    y: CENTER + RADIUS * Math.sin(rad),
    angle: angleDeg,
  };
});

const PRIMARY = "#DA2128";
const ACCENT = "#FF6A3D";

/* --------------- Beautiful orbital infographic --------------- */
function OrbitalInfographic({ active, setActive }) {
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[510px]">
      {/* Outer soft glow */}
      <div
        className="absolute inset-0 rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle at center, rgba(218,33,40,0.12) 0%, rgba(255,106,61,0.05) 40%, transparent 70%)",
        }}
      />

      <svg
        viewBox="0 0 400 400"
        className="absolute inset-0 h-full w-full"
        fill="none"
      >
        <defs>
          <radialGradient id="hubGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor={PRIMARY} stopOpacity="0.35" />
            <stop offset="60%" stopColor={PRIMARY} stopOpacity="0.08" />
            <stop offset="100%" stopColor={PRIMARY} stopOpacity="0" />
          </radialGradient>
          <linearGradient id="activeLine" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={PRIMARY} />
            <stop offset="100%" stopColor={ACCENT} />
          </linearGradient>
          <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
            <feOffset dx="0" dy="4" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.25" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="5" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Outer fill glow for center */}
        <circle cx={CENTER} cy={CENTER} r="180" fill="url(#hubGlow)" />

        {/* Two slowly rotating orbit rings */}
        <g style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}>
          <motion.circle
            cx={CENTER}
            cy={CENTER}
            r={RADIUS + 10}
            stroke={PRIMARY}
            strokeOpacity="0.12"
            strokeWidth="1"
            strokeDasharray="2 6"
            fill="none"
            animate={{ rotate: 360 }}
            transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
            style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
          />
        </g>
        <g style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}>
          <motion.circle
            cx={CENTER}
            cy={CENTER}
            r={RADIUS - 18}
            stroke={ACCENT}
            strokeOpacity="0.18"
            strokeWidth="1"
            strokeDasharray="1 4"
            fill="none"
            animate={{ rotate: -360 }}
            transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
            style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
          />
        </g>

        {/* Static outer orbit */}
        <circle
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          stroke={PRIMARY}
          strokeOpacity="0.2"
          strokeWidth="1"
          fill="none"
        />

        {/* Curved arc connectors (quadratic curves for organic look) */}
        {nodePositions.map((pos, i) => {
          const isActive = active === i;
          // control point slightly pulled toward center for a soft arc
          const midX = (CENTER + pos.x) / 2;
          const midY = (CENTER + pos.y) / 2;
          // Pull curve toward the center slightly
          const dx = CENTER - midX;
          const dy = CENTER - midY;
          const dist = Math.sqrt(dx * dx + dy * dy);
          const pull = 18; // curve amount
          const cpX = midX + (dx / dist) * pull;
          const cpY = midY + (dy / dist) * pull;
          return (
            <g key={`arc-${i}`}>
              <motion.path
                d={`M ${CENTER} ${CENTER} Q ${cpX} ${cpY} ${pos.x} ${pos.y}`}
                stroke={isActive ? "url(#activeLine)" : "#DA2128"}
                strokeOpacity={isActive ? 1 : 0.25}
                strokeWidth={isActive ? 2.5 : 1.2}
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0, opacity: 0 }}
                whileInView={{ pathLength: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.9,
                  delay: 0.3 + i * 0.12,
                  ease: "easeOut",
                }}
              />
            </g>
          );
        })}

        {/* Tiny decorative tick dots on the orbit */}
        {nodePositions.map((pos, i) => {
          // put small dots halfway along the orbit between each node
          const midAngle = pos.angle + 30;
          const rad = (midAngle * Math.PI) / 180;
          const mx = CENTER + RADIUS * Math.cos(rad);
          const my = CENTER + RADIUS * Math.sin(rad);
          return (
            <motion.circle
              key={`tick-${i}`}
              cx={mx}
              cy={my}
              r="2"
              fill={PRIMARY}
              fillOpacity="0.4"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 1 + i * 0.1 }}
            />
          );
        })}
      </svg>

      {/* Center hub */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 180, damping: 14, delay: 0.1 }}
        className="absolute left-[40%] top-[40%] -translate-x-1/2 -translate-y-1/2"
      >
        {/* Pulsing rings */}
        <motion.span
          className="absolute left-[-8%] top-[-7%] block h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{ backgroundColor: PRIMARY, opacity: 0.1 }}
          animate={{ scale: [1, 1.35, 1], opacity: [0.15, 0, 0.15] }}
          transition={{
            duration: 3.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.span
          className="absolute left-[-16%] top-[-13%] block h-36 w-36 -translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{ backgroundColor: ACCENT, opacity: 0.08 }}
          animate={{ scale: [1, 1.5, 1], opacity: [0.12, 0, 0.12] }}
          transition={{
            duration: 3.2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1.2,
          }}
        />

        {/* Main hub with logo */}
        <div
          className="relative flex h-28 w-28 flex-col items-center justify-center rounded-full text-white shadow-2xl ring-4 ring-white overflow-hidden"
          style={{
            // background: `radial-gradient(circle at 30% 30%, #ff5c63 0%, ${PRIMARY} 55%, #8f0f14 100%)`,
            boxShadow: `0 20px 50px -10px ${PRIMARY}60, 0 0 0 8px ${PRIMARY}10`,
          }}
        >
          {/* Blinking/Animated Logo */}
          <motion.img
            src="https://www.assocham.org/assocham_backend/assets/images/preloader.png"
            alt="ASSOCHAM Logo"
            className="h-20 w-20 object-contain z-10"
            animate={{
              scale: [1, 1.08, 1],
              opacity: [0.95, 1, 0.95],
            }}
            transition={{
              duration: 2.2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          {/* Glass highlight */}
          <div
            className="absolute top-2 left-3 h-6 w-10 rounded-full bg-white/25 blur-md z-20"
            style={{ borderRadius: "50%" }}
          />
        </div>
      </motion.div>

      {/* Outer nodes (positioned with percentages for responsiveness) */}
      {focusAreas.map((area, i) => {
        const pos = nodePositions[i];
        const Icon = area.icon;
        const isActive = active === i;
        const leftPct = (pos.x / 440) * 100;
        const topPct = (pos.y / 460) * 100;

        // Label positioning: push label outward from center
        const rad = (pos.angle * Math.PI) / 180;
        const labelOffset = 46;
        const labelX = pos.x + labelOffset * Math.cos(rad);
        const labelY = pos.y + labelOffset * Math.sin(rad);
        const labelLeftPct = (labelX / 430) * 100;
        const labelTopPct = (labelY / 440) * 100;

        return (
          <div key={area.number}>
            {/* Node button */}
            <motion.button
              initial={{ scale: 0, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{
                type: "spring",
                stiffness: 220,
                damping: 16,
                delay: 0.6 + i * 0.1,
              }}
              animate={{
                y: isActive ? -3 : 0,
              }}
              whileHover={{ scale: 1.1, y: -3 }}
              onMouseEnter={() => setActive(i)}
              className="absolute z-20 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
              style={{ left: `${leftPct}%`, top: `${topPct}%` }}
            >
              {/* outer ring when active */}
              {isActive && (
                <motion.span
                  layoutId="nodeGlow"
                  className="absolute inset-[-8px] rounded-2xl"
                  style={{
                    background: `linear-gradient(135deg, ${PRIMARY}40, ${ACCENT}30)`,
                    filter: "blur(10px)",
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 25,
                  }}
                />
              )}
              <motion.div
                className={`relative flex h-[52px] w-[52px] items-center justify-center rounded-2xl ring-1 transition-all duration-300 ${
                  isActive
                    ? "text-white ring-white/60"
                    : "bg-white text-[#DA2128] ring-gray-200 shadow-md"
                }`}
                animate={{
                  background: isActive
                    ? `linear-gradient(135deg, ${PRIMARY} 0%, ${ACCENT} 100%)`
                    : "#ffffff",
                  boxShadow: isActive
                    ? `0 12px 30px -8px ${PRIMARY}80`
                    : "0 4px 12px -4px rgba(0,0,0,0.08)",
                }}
                transition={{ duration: 0.3 }}
              >
                <Icon size={22} strokeWidth={2.2} />
              </motion.div>
            </motion.button>

            {/* Outer label pill */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.9 + i * 0.1, duration: 0.4 }}
              className="pointer-events-none absolute z-10 -translate-x-1/2 -translate-y-1/2"
              style={{
                left: `${labelLeftPct}%`,
                top: `${labelTopPct}%`,
              }}
            >
              <span
                className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[10px] font-bold tracking-wide transition-all duration-300 ${
                  isActive
                    ? "bg-gradient-to-r from-[#DA2128] to-[#FF6A3D] text-white shadow-md"
                    : "bg-white/90 text-gray-700 shadow-sm ring-1 ring-gray-200/70 backdrop-blur-sm"
                }`}
              >
                {area.short}
              </span>
            </motion.div>
          </div>
        );
      })}

      {/* Corner sparkle decorations */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 1.4 }}
        className="absolute top-4 right-6 text-amber-400"
      >
        <motion.span
          animate={{ rotate: [0, 15, -15, 0], scale: [1, 1.2, 1] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="inline-block"
        >
          <Sparkles size={14} />
        </motion.span>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 1.6 }}
        className="absolute bottom-8 left-4 text-[#DA2128]/70"
      >
        <motion.span
          animate={{ rotate: [0, -20, 20, 0], scale: [1, 1.3, 1] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          className="inline-block"
        >
          <Sparkles size={12} />
        </motion.span>
      </motion.div>
    </div>
  );
}

export default function FocusArea() {
  const [active, setActive] = useState(0);
  const activeArea = focusAreas[active];

  return (
    <section
      id="focus"
      className="relative overflow-hidden bg-gradient-to-b from-white via-[#FFFAF8] to-white py-20 md:py-28"
    >
      {/* Decorative background orbs */}
      <div className="pointer-events-none absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full bg-[#DA2128]/[0.07] blur-3xl" />
      <div className="pointer-events-none absolute -left-32 -bottom-32 h-[460px] w-[460px] rounded-full bg-[#FF6A3D]/[0.06] blur-3xl" />
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-72 w-72 -translate-x-1/2 rounded-full bg-amber-200/10 blur-3xl" />

      {/* Subtle grid */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="mb-12 text-center md:mb-16">
          {/* <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-4 inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/20 bg-white px-4 py-1.5 text-[10px] font-bold tracking-[0.25em] text-[#DA2128] uppercase shadow-sm"
          >
            <Sparkles size={10} />
           
          </motion.span> */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="font-serif text-4xl font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
          >
             Our{" "}
             <motion.span 
                className="italic text-[#DA2128]"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
              Focus
            </motion.span>
          </motion.h2>
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="mx-auto mt-4 h-1 w-20 rounded-full bg-gradient-to-r from-[#DA2128] to-[#FF6A3D]"
          />
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mx-auto mt-5 max-w-3xl text-sm leading-relaxed text-gray-600 sm:text-base"
          >
            At ASSOCHAM, the Industry Voice of India, we are committed to
            creating an ecosystem where collaboration drives progress. By
            bringing together industry, government, academia, and global
            stakeholders, we facilitate dialogue, promote innovation, and
            advance initiatives that contribute to India's economic development
            and long-term growth.
          </motion.p>
        </div>

        {/* Two column layout */}
        <div className="grid items-center gap-10 md:grid-cols-2 lg:gap-14">
          {/* LEFT: Infographic */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="relative mx-auto w-full max-w-[510px]"
          >
            <OrbitalInfographic active={active} setActive={setActive} />

            {/* Active label under infographic (mobile+desktop) */}
            {/* <AnimatePresence mode="wait">
              <motion.div
                key={activeArea.number}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-6 rounded-2xl border border-gray-200/70 bg-white/80 p-4 text-center shadow-sm backdrop-blur-sm"
              >
               
                <p className="mt-1 text-base font-bold text-gray-900 sm:text-lg">
                  {activeArea.title}
                </p>
              </motion.div>
            </AnimatePresence> */}
          </motion.div>

          {/* RIGHT: Focus cards */}
          <div className="space-y-3">
            {focusAreas.map((area, i) => {
              const Icon = area.icon;
              const isActive = active === i;
              return (
                <motion.div
                  key={area.number}
                  initial={{ opacity: 0, x: 40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.07 }}
                  onMouseEnter={() => setActive(i)}
                  className={`group relative flex cursor-pointer items-center gap-4 overflow-hidden rounded-2xl border p-4 transition-all duration-300 sm:p-5 ${
                    isActive
                      ? "border-transparent bg-white shadow-xl shadow-[#DA2128]/10"
                      : "border-gray-200/70 bg-white/60 hover:border-[#DA2128]/20 hover:bg-white hover:shadow-md"
                  }`}
                  style={{
                    background: isActive
                      ? "linear-gradient(110deg, #ffffff 0%, #fff5f3 100%)"
                      : undefined,
                  }}
                >
                  {/* Left gradient accent */}
                  <motion.div
                    initial={false}
                    animate={{ scaleY: isActive ? 1 : 0, opacity: isActive ? 1 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="absolute left-0 top-0 h-full w-1 origin-top bg-gradient-to-b from-[#DA2128] to-[#FF6A3D]"
                  />

                  {/* Number */}
                  {/* <span
                    className={`absolute top-3 right-4 text-[10px] font-black tracking-wider transition-colors ${
                      isActive ? "text-[#DA2128]" : "text-gray-300"
                    }`}
                  >
                    {area.number}
                  </span> */}

                  {/* Icon */}
                  <motion.div
                    animate={{
                      background: isActive
                        ? `linear-gradient(135deg, ${PRIMARY}, ${ACCENT})`
                        : "rgba(218,33,40,0.08)",
                      color: isActive ? "#ffffff" : "#DA2128",
                      scale: isActive ? 1.05 : 1,
                    }}
                    whileHover={{ rotate: [0, -6, 6, 0] }}
                    transition={{ duration: 0.3 }}
                    className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl shadow-sm"
                  >
                    <Icon size={20} strokeWidth={2.2} />
                  </motion.div>

                  {/* Content */}
                  <div className="flex-1 pr-8">
                    <h3 className="text-[15px] font-bold leading-snug text-gray-900 sm:text-base">
                      {area.title}
                    </h3>
                    <AnimatePresence initial={false}>
                      {isActive && (
                        <motion.p
                          key={`desc-${area.number}`}
                          initial={{ opacity: 0, height: 0, marginTop: 0 }}
                          animate={{
                            opacity: 1,
                            height: "auto",
                            marginTop: 6,
                          }}
                          exit={{ opacity: 0, height: 0, marginTop: 0 }}
                          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                          className="overflow-hidden text-[13px] leading-relaxed text-gray-600"
                        >
                          {area.desc}
                        </motion.p>
                      )}
                    </AnimatePresence>
                  </div>

                  {/* Arrow icon on active */}
                  <motion.div
                    animate={{
                      opacity: isActive ? 1 : 0,
                      x: isActive ? 0 : -4,
                    }}
                    transition={{ duration: 0.25 }}
                    className="absolute right-4 bottom-4 self-end"
                  >
                    <div
                      className="flex h-7 w-7 items-center justify-center rounded-full text-white"
                      style={{
                        background: `linear-gradient(135deg, ${PRIMARY}, ${ACCENT})`,
                      }}
                    >
                      <ArrowUpRight size={14} strokeWidth={2.5} />
                    </div>
                  </motion.div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}